import { InitialFormStateType } from 'new/form/model';

import { FieldTypes } from '../fields';

export const initialFormState: InitialFormStateType<FieldTypes> = {
  currentStep: 'contractDetails',
  inquiryMode: 'editCustomer',
  pageValidations: {
    contractDetails: {
      progress: { numberOfValidSections: 2, numberOfSections: 4, isSectionValid: false },
      validations: {
        dealerSection: true,
        financingObjectSection: false,
        financingConditionsSection: true,
        bankDetailsSection: false,
      },
    },
    customerDataPage: {
      progress: { numberOfValidSections: 2, numberOfSections: 4, isSectionValid: false },
      validations: {
        companySection: true,
        contactPersonSection: true,
        authorizationOfRepresentationSection: false,
        beneficialOwnerSection: false,
      },
    },
  },
};
